import { create } from "zustand";

interface ShellState {
  headerVisible: boolean;
  footerVisible: boolean;
  headerHideCount: number;
  footerHideCount: number;
}

interface ShellActions {
  setHeaderVisible: (visible: boolean) => void;
  setFooterVisible: (visible: boolean) => void;
  toggleHeader: () => void;
  toggleFooter: () => void;
  showHeader: () => void;
  hideHeader: () => void;
  showFooter: () => void;
  hideFooter: () => void;
}

export type ShellStore = ShellState & ShellActions;

const initialDefaultState: ShellState = {
  headerVisible: true,
  footerVisible: true,
  headerHideCount: 0,
  footerHideCount: 0,
};

export const useShellStore = create<ShellStore>()((set) => ({
  ...initialDefaultState,
  setHeaderVisible: (headerVisible) =>
    set({
      headerHideCount: headerVisible ? 0 : 1,
      headerVisible,
    }),
  setFooterVisible: (footerVisible) =>
    set({
      footerHideCount: footerVisible ? 0 : 1,
      footerVisible,
    }),
  toggleHeader: () =>
    set((state) => ({
      headerHideCount: state.headerVisible ? 1 : 0,
      headerVisible: !state.headerVisible,
    })),
  toggleFooter: () =>
    set((state) => ({
      footerHideCount: state.footerVisible ? 1 : 0,
      footerVisible: !state.footerVisible,
    })),
  showHeader: () =>
    set((state) => {
      const headerHideCount = Math.max(0, state.headerHideCount - 1);

      return {
        headerHideCount,
        headerVisible: headerHideCount === 0,
      };
    }),
  hideHeader: () =>
    set((state) => ({
      headerHideCount: state.headerHideCount + 1,
      headerVisible: false,
    })),
  showFooter: () =>
    set((state) => {
      const footerHideCount = Math.max(0, state.footerHideCount - 1);

      return {
        footerHideCount,
        footerVisible: footerHideCount === 0,
      };
    }),
  hideFooter: () =>
    set((state) => ({
      footerHideCount: state.footerHideCount + 1,
      footerVisible: false,
    })),
}));
